import React from "react";
import { NavLink, Redirect, Route, Switch } from "react-router-dom";

import PageHeader from "designV2/components/PageHeader";
import "./settings.css";

/**
 * SettingsTabs - the frame around each group of settings screens.
 *
 * Vehicle options, product options, default texts and roles were four
 * hand-written copies of the same nav-plus-switch, all borrowing the
 * shop page's stylesheet. They describe their tabs here instead.
 *
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.description - One line on what the group covers
 * @param {string} props.base - Path the tabs hang off, no trailing slash
 * @param {Array} props.tabs - [{ path, label, component }], first is the default
 */
const SettingsTabs = ({ title, description, base, tabs }) => (
  <div className="page settingsPage">
    <main className="main">
      <PageHeader title={title} description={description} />

      <nav className="settingsTabs">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={base + tab.path}
            className="settingsTab"
            activeClassName="isActive"
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <div className="settingsPanel">
        <Switch>
          {tabs.map((tab) => (
            <Route key={tab.path} exact path={base + tab.path} component={tab.component} />
          ))}
          <Redirect from={base} to={base + tabs[0].path} />
        </Switch>
      </div>
    </main>
  </div>
);

export default SettingsTabs;
